import PropTypes from 'prop-types'
import { ResponsiveContainer, BarChart, Bar, YAxis, XAxis, Tooltip, Cell } from 'recharts'

import { colors } from '../../utils'

const TotalsChart = ({ chartData, onBarClick }) => {

    const findMostGames = () => {
        const mostGames = chartData.reduce((acc, curr) => {
            if (acc.wins + acc.losses > curr.wins + curr.losses) {
                return acc
            }
            return curr
        })
        return mostGames
    }

    const handleClick = (data) => onBarClick(data.name)

    return (
        <ResponsiveContainer width='100%' height={300}>
            <BarChart layout='vertical' margin={{ left: 20 }} data={chartData}>
                <YAxis type='category' dataKey='name' />
                <XAxis type='number' domain={[0, findMostGames()]} hide />
                <Tooltip />
                <Bar dataKey='wins' stackId='a' onClick={handleClick} >
                    {chartData.map((entry) => <Cell cursor='pointer' key={`${entry.name}-win`} fill={colors[entry.name.toLowerCase()][0]} />)}
                </Bar>
                <Bar dataKey='losses' stackId='a' onClick={handleClick} style={{ cursor: 'pointer' }}>
                    {chartData.map((entry) => <Cell cursor='pointer' key={`${entry.name}-lose`} fill={colors[entry.name.toLowerCase()][1]} />)}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}

TotalsChart.propTypes = {
    chartData: PropTypes.array.isRequired,
    onBarClick: PropTypes.func.isRequired,
}

export default TotalsChart